import { Button, Card, Col, Form, Modal, Pagination, Popconfirm, Row, Typography, Upload, message, theme } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, PAGESIZEOPTION } from "../config/serverApiConfig";
import { nanoid } from "nanoid";

const { Title } = Typography;
function Reels() {
  const { useToken } = theme;
  const { token } = useToken();

 

  const [visible, setVisible] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [, setLoading] = React.useState(false);
  const [, setRec] = React.useState({});
  const [update, setUpdate] = React.useState(false);

  const [Work] = Form.useForm();
const submitReels = async (values) => {
  setConfirmLoading(true);
  setLoading(true);

  try {
    // 1) Get the selected file from AntD Upload (we used name="video" in the Form.Item)
    const fileObj = values?.video?.fileList?.[0]?.originFileObj;
    if (!fileObj) {
      message.error("تکایە ڤیدیۆکە هەڵبژێرە");
      return;
    }

    // 2) Build FormData exactly as backend expects: field name must be "reel"
    const formData = new FormData();
    formData.append("reel", fileObj);

    // 3) POST to /reels
    const { data: created } = await axios.post(`${API_BASE_URL}reels`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      // Optional: track progress
      // onUploadProgress: (e) => {
      //   const pct = Math.round((e.loaded * 100) / (e.total || 1));
      //   console.log("upload:", pct, "%");
      // },
    });

    // 4) Success UI + local state update
    message.success("ڕیڵز بەسەرکەوتوویی زیادکرا");
    Work.resetFields();
    setVisible(false);
    console.log(created);

    // Prepend new reel to current list
   setTimeout(() => {
    setData((prevData) => ({
      data: [created, ...prevData.data],
      pagination: prevData.pagination,
    }))
  }, 5000);


   
  } catch (err) {
    console.error(err);
    message.error("هەڵەیەک هەیە لە زیادکردنی ڕیڵز");
  } finally {
    setConfirmLoading(false);
    setLoading(false);
  }
};


  const [data, setData] = React.useState({
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });




  const handleOnChange = useCallback((pagination, filter, sorter) => {
    setLoading(true);

    axios
      .get(`${API_BASE_URL}reels`, {
        params: {
          page: pagination.current,
          size: pagination.pageSize,
        },
      })
      .then((res) => {
        setData({
          data: res.data.data,
          pagination: {
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: res.data.total,
          },
        });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleChange = (page, pageSize) => {};

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handleDelete = (i) => {
    axios
      .delete(`${API_BASE_URL}reels/${i.id}`)
      .then((res) => {
        // message.success("پرسیارەکەت بەسەرکەوتویی سڕایەوە");
        message.success("ڕیڵز بەسەرکەوتوویی سڕایەوە");
        setData({
          data: data.data.filter((item) => item.id !== i.id),
          pagination: data.pagination,
        });
      })
      .catch((err) => {
        console.log(err);
        message.error("هەڵەیەک هەیە لە سڕینەوەی ڕیڵز");
      });
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}reels?size=1000`)
      .then((res) => {
        console.log(res.data, "❤️❤️❤️😂😂");

        setData({
          data: res.data.content,
          pagination: {
            current: res.data.pageable.pageNumber + 1,
            pageSize: res.data.pageable.pageSize,
            total: res.data.totalElements,
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleEdit = (i) => {
    setUpdate(true);
    setVisible(true);
    Work.setFieldsValue({
      titleKu: i.titleKu,
      titleAr: i.titleAr,
      titleEn: i.titleEn,
      year: i.year,
    });
    setRec(i);
  };


  const isCloudflareStream = (url = "") =>
  typeof url === "string" && url.includes("cloudflarestream.com");

const getCloudflareUid = (item) => {
  if (item?.cloudflareVideoId) return item.cloudflareVideoId;
  try {
    const u = new URL(item?.reelUrl || "");
    const parts = u.pathname.split("/").filter(Boolean);
    // parts[0] should be the UID
    return parts?.[0] || null;
  } catch {
    return null;
  }
};

const buildCfIframeSrc = (reelUrl, uid) => {
  if (!reelUrl || !uid) return null;
  const u = new URL(reelUrl);
  return `${u.origin}/${uid}/iframe`;
};

  return (
    <div style={{ margin: 10, padding: 10 }}>
      <Row style={{ marginTop: 10, backgroundColor: token.colorBgContainer, borderRadius: token.borderRadius, padding: token.padding }} justify={"space-between"}>
        <Col>
          <Title level={4}>ڕیــــڵــــز</Title>
        </Col>

        <Col>
          <Button onClick={() => setVisible(true)} type="primary">
            زیادکردن
          </Button>
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        {data.data.map((item) => {
          const key = item.id ?? item._id ?? nanoid(6);
         
          return (
            <Col key={key} xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
              <Card
                style={{ backgroundColor: token.colorBgContainer }}
                bodyStyle={{ padding: 12 }}
                title={<span style={{ fontWeight: 600 }}>{item.titleKu ?? item.titleEn ?? ""}</span>}
                extra={
                  <Row gutter={4} wrap={false}>
                   
                    <Col>
                      <Popconfirm title="ئایا دڵنیایت لە سڕینەوەی ئەم ڤیدیۆیە؟" onConfirm={() => handleDelete(item)} okText="بەڵێ" cancelText="نەخێر">
                        <Button type="text" danger icon={<DeleteOutlined />} />
                      </Popconfirm>
                    </Col>
                  </Row>
                }
              >
        {item.reelUrl ? (
  isCloudflareStream(item.reelUrl) ? (
    // Cloudflare video -> iframe player (responsive)
    (() => {
      const uid = getCloudflareUid(item);
      const src = buildCfIframeSrc(item.reelUrl, uid);
      if (!src) {
        return <div style={{ height: 180, display:'flex', alignItems:'center', justifyContent:'center', opacity:.6 }}>UID نادیارە</div>;
      }
      // Responsive 16:9 wrapper
      return (
        <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
          <iframe
            src={src}
            style={{ border: 'none', position: 'absolute', inset: 0, width: '100%', height: '100%' }}
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
            title={`reel-${item.id}`}
          />
        </div>
      );
    })()
  ) : (
    // Non-Cloudflare (e.g., GitHub raw MP4) -> plain video tag
    <video
      src={item.reelUrl}
      controls
      preload="metadata"
      style={{ width: '100%', borderRadius: 10 }}
    />
  )
) : (
  <div style={{ height: 180, display: "flex", alignItems: "center", justifyContent: "center", opacity: 0.6 }}>
    هیچ ڤیدیۆیەک نییە
  </div>
)}
                
              </Card>
            </Col>
          );
        })}
      </Row>

      <Row justify={"end"}>
        <Pagination pageSizeOptions={PAGESIZEOPTION} onChange={handleChange} style={{ marginTop: 20 }} current={1} total={4} />
      </Row>

      <Modal
        onOk={() => Work.submit()}
        open={visible}
        centered
        okText={update ? "نوێکردنەوە" : "زیادکردن"}
        cancelText="پاشگەزبوونەرە"
        confirmLoading={confirmLoading}
        onCancel={() => {
          setVisible(false);
          setUpdate(false);
          Work.resetFields();
        }}
        title={
          <Title style={{ color: "#59114d" }} level={5}>
            زیاد کردنی ڕیڵز
          </Title>
        }
      >
        <Form.Provider
          onFormFinish={(name, { values, forms }) => {
            if (name === "JPS") {
              submitReels(values);
            }
          }}
        >
          <Form name="JPS" form={Work} layout="horizontal">
            {/* <Title level={5}>جۆری کار</Title> */}
<Title level={5} style={{ marginTop: 8 }}>ڤیدیۆ</Title>
            <Form.Item
              style={{ marginBottom: 8 }}
              label="Video"
              name="video"
              rules={update ? [] : [{ required: true, message: "ڤیدیۆ داگرە" }]}
              // Keeping Upload's default value shape (object with fileList) for compatibility with your old code
            >
              <Upload
                maxCount={1}
accept="video/*,.mov,.hevc,.h265,.hvec,.m4v,.qt"
                // beforeUpload={fileTooLarge}
                listType="text"
                customRequest={dummyRequest}
              >
                <Button icon={<PlusOutlined />}>Upload video</Button>
              </Upload>
            </Form.Item>
          
          </Form>
        </Form.Provider>
      </Modal>
    </div>
  );
}

export default Reels;
